import React, { CSSProperties } from 'react';
import { IMultiSelectOptionList } from '~/helpers/interfaces';
import MultiSelectCheckBox from './MultiSelectCheckBox';

interface IProps {
  options: IMultiSelectOptionList[];
  setSelectedOption: (value: string, isSelected: boolean) => void;
  checkTintColor?: string;
  tickColor?: string;
  enableLabelClickToSelect?: boolean;
  styles?: CSSProperties;
  checkboxContainerStyles?: CSSProperties;
  useSwitch?: boolean;
}
const MultiSelectCheckboxList = (props: IProps) => {
  const {
    options,
    setSelectedOption,
    checkTintColor,
    tickColor,
    enableLabelClickToSelect = false,
    styles,
    useSwitch = false,
    checkboxContainerStyles
  } = props;

  return (
    <div style={styles}>
      {options.map((option, index) => (
        <div
          key={index}
          style={option.containerStyle}
          {...(enableLabelClickToSelect
            ? {
                onClick: () =>
                  setSelectedOption(option.value, !option.isSelected)
              }
            : {})}
        >
          <MultiSelectCheckBox
            index={index}
            option={option}
            setSelectedOption={setSelectedOption}
            checkTintColor={checkTintColor}
            tickColor={tickColor}
            useSwitch={useSwitch}
            styles={checkboxContainerStyles}
            textStyle={option.textStyle}
          />
          {option.showSibling && option.sibling}
        </div>
      ))}
    </div>
  );
};
export default MultiSelectCheckboxList;
